import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';

const ProductQuantitySelector = ({ quantity, handleChange, handleDecrease, handleIncrease, mobile }) => (
  <Quantity mobile={mobile}>
    <QuantityButton
      type="button"
      title="Öka kvantitet"
      icon="-"
      onClick={handleDecrease}
      disabled={quantity <= 1}
      mobile={mobile}
    />
    <QuantityInput
      value={quantity}
      type="number"
      pattern="[0-9]*"
      onChange={event => handleChange((event.target.validity.valid && event.target.valueAsNumber) ? event.target.valueAsNumber : 1)}
      mobile={mobile}
    />
    <QuantityButton
      type="button"
      title="Minska kvantitet"
      icon="+"
      onClick={handleIncrease}
      disabled={quantity >= 999}
      mobile={mobile}
    />
  </Quantity>
);

ProductQuantitySelector.defaultProps = {
  quantity: 1,
  handleChange: () => {},
  handleDecrease: () => {},
  handleIncrease: () => {},
  mobile: false,
};

ProductQuantitySelector.propTypes = {
  quantity: PropTypes.number,
  handleChange: PropTypes.func,
  handleDecrease: PropTypes.func,
  handleIncrease: PropTypes.func,
  mobile: PropTypes.bool,
};

export default ProductQuantitySelector;

const Quantity = styled.div`
  flex: 0 0 100%;
  display: flex;
  align-items: center;
  margin: 0 0 15px 0;
  @media screen and (min-width: 1150px) {
    flex: 1 1 auto;
    margin: 0 15px 0 0;
  }
  &:last-child {
    margin: 0;
  }
  ${props => props.mobile && css`
    @media screen and (min-width: 320px) {
      flex: 1 1 auto;
      margin: 0 15px 0 0;
    }
  `};
`;
const QuantityButton = styled.button`
  height: 56px;
  width: 45px;
  padding: 15px;
  border: none;
  outline: none;
  background-color: white;
  &:active {
    box-shadow: 0 0 10px rgb(0 0 0 / 0.1);
  }
  &:disabled {
    &:before,
    &:after {
      opacity: 0.5;
    }
  }
  ${props =>
    props.icon === '-' &&
    css`
    position: relative;
    &:after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      height: 1px;
      width: 10px;
      background-color: black;
      transform: translate(-50%, -50%);
    }
    `};
  ${props =>
    props.icon === '+' &&
    css`
    position: relative;
    &:before,
    &:after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      background-color: black;
      transform: translate(-50%, -50%);
    }
    &:before {
      height: 1px;
      width: 10px;
    }
    &:after {
      height: 10px;
      width: 1px;
    }
    `};
  ${props => props.mobile && css`
    height: 43px;
    width: 40px;
  `};
`;

const QuantityInput = styled.input`
  flex: 1 1 auto;
  height: 56px;
  width: 30px;
  padding: 15px 0;
  border: none;
  outline: none;
  background-color: white;
  color: black;
  font-family: 'Open Sans';
  font-size: 16px;
  line-height: 1.25;
  font-weight: 400;
  text-align: center;
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  &[type=number] {
    -moz-appearance: textfield;
  }
  ${props => props.mobile && css`
    height: 43px;
  `};
`;



// WEBPACK FOOTER //
// ./src/components/productPage/ProductQuantitySelector/ProductQuantitySelector.js